import { Box, Typography } from "@mui/material";

const ItemRentalDetails = ({ productData }) => {


  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Typography
        sx={{
          fontSize: { sm: "18px", xs: "16px" },
          fontFamily: "ABLE",
          lineHeight: "35px",
          fontWeight: "600",
          color: "#000",
        }}
      >
        {productData?.name} 
      </Typography>
      <Typography
        sx={{
          fontSize: { sm: "18px", xs: "16px" },
          fontFamily: "ABLE",
          lineHeight: "35px",
          fontWeight: "600",
          color: "#000",
        }}
      >
        $ {parseFloat(productData?.price).toFixed(2)}
      </Typography>
    </Box>
  );
};

export default ItemRentalDetails;
